import React, { useState } from 'react';
import AddService from './AddService';
import ServicesList from './ServicesList';
import ServicesEditor from './ServicesEditor';
import Headerpage from '../Headerpage';
import './AddServicesPage.css';

function AddServicesPage() {
  const [activePage, setActivePage] = useState('list');
  const [menuOpen, setMenuOpen] = useState(false);

  const renderContent = () => {
    switch (activePage) {
      case 'list':
        return <ServicesList />;
      case 'add':
        return <AddService />;
      case 'edit':
        return <ServicesEditor />;
      default:
        return <ServicesList />;
    }
  };

  // setActivePage

  const handleNavButtonClick = (page) => {
    setActivePage(page);
    setMenuOpen(false);  // Close the dropdown when a button is clicked
  };

  return (
    <div className="dashboard-container">
      <Headerpage />

      {/* Top Navigation */}
      <div className="top-nav-container">
        <button
          className="menu-toggle-btn"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>
        <ul className={`top-nav ${menuOpen ? 'open' : ''}`}>
          <li>
            <button
              className={`nav-btn ${activePage === 'list' ? 'active' : ''}`}
              onClick={() => handleNavButtonClick('list')}
            >
              📋 Services List
            </button>
          </li>
          <li>
            <button
              className={`nav-btn ${activePage === 'add' ? 'active' : ''}`}
              onClick={() => handleNavButtonClick('add')}
            >
              ➕ Add Service
            </button>
          </li>
          <li>
            <button
              className={`nav-btn ${activePage === 'edit' ? 'active' : ''}`}
              onClick={() => handleNavButtonClick('edit')}
            >
              ✏️ Edit Service
            </button>
          </li>
        </ul>
      </div>

      {/* Main content */}
      <main className="content-area">{renderContent()}</main>
    </div>
  );
}

export default AddServicesPage;
